import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { StatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'membership_tier_activity'

type MembershipsTierActivityRow = {
  migrated_from_to: string
  quantity: number
}

export const useMembershipsTierActivityReportCard = (): StatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({ reportId })

  const data = createStatsData<MembershipsTierActivityRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label: row.migrated_from_to,
      value: row.quantity,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'stats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Tier activity',
      tooltip: {
        title: 'Tier activity',
        description: 'Breakdown of member upgrades and downgrades between tiers.',
      },
    },
  }
}
